import { Node, mergeAttributes } from "@tiptap/core";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        mergeTag: {
            insertMergeTag: (tag: string, fallback?: string) => ReturnType;
        };
    }
}

/** Inline atom rendering a {{merge.tag}} chip. Serialized into the document
 * as a RichDoc mergeTag node. */
export const MergeTag = Node.create({
    name: "mergeTag",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    addAttributes() {
        return {
            tag: { default: "" },
            fallback: { default: undefined },
        };
    },

    parseHTML() {
        return [{ tag: "span[data-merge-tag]" }];
    },

    renderHTML({ node, HTMLAttributes }) {
        const tag = String(node.attrs.tag ?? "");
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                "data-merge-tag": tag,
                class: "merge-tag-chip",
                contenteditable: "false",
            }),
            `{{${tag}}}`,
        ];
    },

    addCommands() {
        return {
            insertMergeTag:
                (tag: string, fallback?: string) =>
                ({ chain }) =>
                    chain()
                        .insertContent({ type: this.name, attrs: { tag, fallback } })
                        .run(),
        };
    },
});
